import { useFormContext, Controller } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import { Checkbox } from '@components/Checkbox';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { paymentMethods } from '@constants/companies';

const Form = styled('div')({
    maxWidth: 698,
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
    gridGap: '4px 16px',
    '@media (max-width: 1024px)': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        maxWidth: 'none',
    },
});

const MethodWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    transform: 'translateX(-7px)',
    '& .MuiCheckbox-root': {
        padding: 4,
    },
});

const PaymentMethods = () => {
    const { t } = useTranslation();
    const { control, setValue } = useFormContext();

    return (
        <Form>
            {paymentMethods.map((method, index) => (
                <MethodWrapper key={method.name}>
                    <Controller
                        control={control}
                        name={`paymentMethods.${index}.value`}
                        render={({ field, ref }) => (
                            <Checkbox
                                ref={ref}
                                inputProps={{ 'aria-label': 'controlled' }}
                                onChange={e => {
                                    setValue(`paymentMethods.${index}.value`, e.target.checked, {
                                        shouldDirty: true,
                                    });
                                }}
                                checked={field.value}
                            />
                        )}
                    />
                    <Typography variant="body2">{t(`paymentMethod.${method.name}`)}</Typography>
                </MethodWrapper>
            ))}
        </Form>
    );
};

export default PaymentMethods;
